import './RegistrationStatus.css';

// Animated status screen shown on /register when registration is not open.
// mode: 'soon' (before open) | 'closed' (after end)
function RegistrationStatus({ mode = 'soon', openDate = null }) {
  const isSoon = mode === 'soon';

  const formatDate = (d) =>
    d
      ? d.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })
      : null;

  return (
    <div className="regstatus-root">
      <div className="regstatus-card">
        <div className={`regstatus-badge ${isSoon ? 'soon' : 'closed'}`}>
          <span className="regstatus-dot" />
          {isSoon ? 'COMING SOON' : 'CLOSED'}
        </div>

        <h1 className={`regstatus-title ${isSoon ? 'soon' : 'closed'}`}>
          {isSoon ? 'Registration Opens Soon' : 'Registration Closed'}
        </h1>

        <div className="regstatus-scanline" />

        <p className="regstatus-sub">
          {isSoon
            ? formatDate(openDate)
              ? <>Player registration opens on <strong>{formatDate(openDate)}</strong></>
              : 'Player registration opens soon. Stay tuned!'
            : 'Player registration for this season has ended. See you next season!'}
        </p>

        {isSoon && (
          <div className="regstatus-pulse-bars" aria-hidden="true">
            <span /><span /><span /><span /><span />
          </div>
        )}
      </div>
    </div>
  );
}

export default RegistrationStatus;
